exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-ukazky-realizaci-js": () => import("./../../../src/pages/ukazky-realizaci.js" /* webpackChunkName: "component---src-pages-ukazky-realizaci-js" */),
  "component---src-pages-vzorniky-js": () => import("./../../../src/pages/vzorniky.js" /* webpackChunkName: "component---src-pages-vzorniky-js" */)
}

